import { restClient } from '../../client';

export type VerifyEmailOutput = {
  error?: string;
};

export const verifyEmail = (code: string) =>
  restClient.request<VerifyEmailOutput>('/api/v1/auth/verify_user_account_email', {
    method: 'POST',
    data: {
      verification_code: code
    }
  });
